<div *ngIf="!showApplyToStep">
  <mbs-alert [type]="'warning'"
             [icon]="true">
    {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.alertInfo' | i18next }}
  </mbs-alert>
</div>

<div *ngIf="!showApplyToStep"
     class="mb-3 bg-secondary border rounded">
  <div class="m-3 row">
    <div class="col-12">
      <div class="font-weight-bold">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.applyTitle' | i18next }}
      </div>
      <div>
        {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.computersCount' | i18next: { value: totalCount } }}
      </div>
    </div>
  </div>
</div>

<div *ngIf="showApplyToStep">
  <mbs-rmm-notifications-apply-profile-to (disableNext)="disableNextForApply($event)">
  </mbs-rmm-notifications-apply-profile-to>
</div>


<div class="bg-secondary border rounded">
  <form [formGroup]="form">

    <div class="m-3 mb-0 row">

      <div class="col-6">
        <mbs-select [label]="'mbs-ui:rmm-custom-alerting.wizard.firstStep.optionSetupLabel' | i18next"
                    [boldLabel]="true"
                    formControlName="action"
                    [appendTo]="'body'"
                    [clearable]="false"
                    [searchable]="false"
                    [items]="actions">
        </mbs-select>
        <div *ngIf="form.get('action').value.key === actionTypes.Global && isNotConfigured && canShowSummaryAndLink">
          <ng-container *ngTemplateOutlet="notConfigured"></ng-container>
        </div>
      </div>

      <div class="col-6"
           *ngIf="enableLoadFromCompany">
        <ng-template *ngTemplateOutlet="selectProfileTemplate"></ng-template>

        <div *ngIf="form.get('action').value.key === actionTypes.Company && isNotConfigured && canShowSummaryAndLink">
          <ng-container *ngTemplateOutlet="notConfigured"></ng-container>
        </div>
      </div>


      <div class="col-6"
           *ngIf="enableLoadFromComputer">
        <ng-template *ngTemplateOutlet="selectProfileTemplate"></ng-template>

        <div *ngIf="form.get('action').value.key === actionTypes.Computer && isNotConfigured && canShowSummaryAndLink">
          <ng-container *ngTemplateOutlet="notConfigured"></ng-container>
        </div>
      </div>

      <div *ngIf="showCustomNotSelectAlert"
           class="col-12 mt-3">
        <mbs-alert class="mb-3"
                   [type]="'warning'"
                   [icon]="true">
          {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.customNotSelectedWarning' | i18next }}
        </mbs-alert>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="form.get('action').value.key === actionTypes.Custom ? customSettings : alertInfo">
    </ng-container>


  </form>
</div>


<ng-template #customSettings>
  <hr>
  <form [formGroup]="customAlertingForm">
    <div class="m-3 mb-0 row">

      <div class="col-5">
        <div class="font-weight-semibold">
          {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.generalAlertType' | i18next }}
        </div>
        <div class="my-1">
          <mbs-checkbox [label]="'Select All'"
                        [checked]="allGeneralAlertSelected"
                        (change)="selectAllClicked($event, true)">
          </mbs-checkbox>
        </div>
        <div *ngFor="let groupName of generalAlerts"
             class="my-1">
          <div [formGroupName]="groupName">
            <mbs-checkbox [label]="'mbs-ui:rmm-custom-alerting.wizard.steps.' + groupName | i18next"
                          formControlName="enabled">
            </mbs-checkbox>
          </div>
        </div>
      </div>

      <div *ngIf="windowsAlertsEnabled"
           class="col-7">
        <div class="font-weight-semibold">
          {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.winAlertType' | i18next }}
        </div>
        <div class="my-1">
          <mbs-checkbox [label]="'Select All'"
                        [checked]="allWindowsAlertSelected"
                        (change)="selectAllClicked($event)">
          </mbs-checkbox>
        </div>
        <div *ngFor="let groupName of windowsAlerts"
             class="my-1">
          <div [formGroupName]="groupName">
            <mbs-checkbox [label]="'mbs-ui:rmm-custom-alerting.wizard.steps.' + (groupName !== 'hardwareChanges' ? groupName : 'hardwareChangesSecond')  | i18next"
                          formControlName="enabled">
            </mbs-checkbox>
          </div>
        </div>

      </div>
    </div>
  </form>
</ng-template>


<ng-template #alertInfo>
  <ng-container *ngIf="canShowSummaryAndLink">
    <hr>
    <div class="m-3">
      <mbs-utility-alert-summary [showAlertsOnly]="true">
      </mbs-utility-alert-summary>
    </div>
  </ng-container>

</ng-template>


<ng-template #notConfigured>
  <span class="text-sm text-danger">{{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.notConfigured' | i18next: {
    value:getSettingsTypeText } }}</span>
</ng-template>

<ng-template #selectProfileTemplate>
  <form [formGroup]="form">
    <mbs-select [label]="'mbs-ui:rmm-custom-alerting.wizard.firstStep.profileSelectionLabel' | i18next"
                [boldLabel]="true"
                [bindLabel]="'name'"
                [bindValue]="'id'"
                formControlName="profileId"
                [appendTo]="'body'"
                [clearable]="true"
                [searchable]="true"
                [typeahead]="typeahead$"
                [items]="profiles">
    </mbs-select>
  </form>
</ng-template>
